{
    "title": "Home Address",
    "input":{
        "country": "Country",
        "state": "State",
        "city": "City",
        "addressLine1": "Address Line 1",
        "addressLine2": "Address Line 2",
        "addressLine3": "Address Line 3",
        "postalCode": "Postal Code",
        "unitNumber": "Unit Number"
    }
}